module.exports = __webpack_public_path__ + "img/sm-youtube.aa4e6190.svg";